import { render, staticRenderFns } from "./ProductActions.vue?vue&type=template&id=78a36cd8&"
import script from "./ProductActions.vue?vue&type=script&lang=ts&"
export * from "./ProductActions.vue?vue&type=script&lang=ts&"
import style0 from "./ProductActions.vue?vue&type=style&index=0&id=78a36cd8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports